<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <a
                v-bind = "attrs"
                v-on   = "on"
                class  = "audit-menu"
            >
                <v-icon color="white" size="24">mdi-menu</v-icon>
            </a>
        </template>

        <div class="white">
            <v-list class="white">
                <v-list-item
                    v-for = "(entry, index) in menu"
                    :key  = "index"
                    link
                >
                    <v-list-item-title
                        @click = "onCategory(entry)"
                    >
                        {{ entry.name }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </div>
    </v-menu>
</template>

<script>
import AuditType from "@/modules/audit/service/AuditType";

export default {
    name: "CAuditMenu",

    props: {
        type: {

        },

        /** GBU type (ELEVATOR/ESCALATOR); escalator GBUs have no facilities and hazards (HCIT-1194). */
        deviceType: {
            required: false,
            default : null
        },

        /** Catalogue set of the GBU type (HCIT-917); the elevator set of the store if not given. */
        enums: {

        }
    },

    computed: {
        auditEnums () {
            return this.enums || this.$store.getters.audit;
        },

        categories () {
            if (!this.auditEnums || !this.auditEnums.categories) {
                return [];
            }

            return this.auditEnums.categories.filter(c => c.area === this.type);
        },
    },

    data: () =>({
        menu    : [],
        category: null
    }),

    mounted() {
        this.load();
    },

    watch: {
        type () {
            this.load();
        },

        deviceType () {
            this.load();
        },

        // a GBU of another type was opened (history, asynchronous loading): show its categories
        auditEnums () {
            this.load();
        }
    },

    methods: {
        load () {
            this.menu = [];
            this.categories.forEach (category => {
                this.menu.push(category);
            });

            if (this.type === "GBU" && AuditType.hasFacilities(this.deviceType)) {
                this.menu.push({
                    id  : 100,
                    name: this.$t("disposition.audit.GBU.facilities")
                })

                this.menu.push({
                    id  : 101,
                    name: this.$t("disposition.audit.GBU.hazards")
                })
            }

            this.onCategory(this.categories[0]);
        },

        onCategory (category) {
            this.category = category;
            this.$emit ("category", category);
        },
    }
}
</script>

<style scoped>

</style>